<template>
  <el-row>
    <div class="queryParamStyle">
      <el-row>
        <el-form :model="queryParams" ref="queryParams" :inline="true" label-width="100px">
          <el-col :span="10">
            <el-form-item label="院系名称：" prop="facultyName">
              <el-input
                      v-model="queryParams.facultyName"
                      placeholder="请输入院系名称"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="专业名称：" prop="majorName">
              <el-input
                      v-model="queryParams.majorName"
                      placeholder="请输入专业名称"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学历：" prop="education">
              <el-input
                      v-model="queryParams.education"
                      placeholder="请输入学历"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="学制：" prop="schoolSystem">
              <el-input
                      v-model="queryParams.schoolSystem"
                      placeholder="请输入学制"
                      clearable
                      size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="14" style="margin-left: 27px">
            <el-form-item label="人数：">
              <el-col :span="7">
                <el-input
                        v-model="queryParams.personStartNum"
                        placeholder="请输入人数"
                        clearable
                        size="small"
                />
              </el-col>
              <el-col :span="2" class="line">-</el-col>
              <el-col :span="7">
                <el-input
                        v-model="queryParams.personEndNum"
                        placeholder="请输入人数"
                        clearable
                        size="small"
                />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="getList" style="margin-right: 20px">搜 索</el-button>
              <el-button type="primary" icon="el-icon-refresh" size="mini" @click="getList" style="margin-right: 20px">重 置</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </div>

   <!-- <el-divider></el-divider>
    <div class="search-page">
      <div class="search-page-order">
        <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='zhpx'}" @click="handleOrder('zhpx')">综合排序</el-button>
        <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='fbsj'}" @click="handleOrder('fbsj')">
          发布时间<i class="el-icon-top" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='fbsj'"></i>
          <i class="el-icon-bottom" v-else></i>
        </el-button>
        <el-button type="text" class="order-filed" :class="{'font-blue':queryParams.orderBy=='rd'}" @click="handleOrder('rd')">
          热度<i class="el-icon-top" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='rd'"></i>
          <i class="el-icon-bottom" v-else></i>
        </el-button>
      </div>
    </div>-->
    <el-divider></el-divider>

    <div class="search-table">
      <el-table v-loading="loading" :data="byssyList" tooltip-effect="light" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
        <el-table-column label="院系名称" align="center" prop="facultyName"/>
        <el-table-column label="专业名称" align="center" prop="majorName" :show-overflow-tooltip="true"/>
        <el-table-column label="学历" align="center" prop="education" width="90" />
        <el-table-column label="学制" align="center" prop="schoolSystem" width="95"  />
        <el-table-column label="人数" align="center" prop="personNum"  width="95" />
        <el-table-column label="联系人" align="center" prop="lxr" width="90"  >
          <template slot-scope="scope">
            <el-tag v-if="!isLoginState">登录后查看</el-tag>
            <span v-if="isLoginState" >{{scope.row.lxr}}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系方式" align="center" prop="tel"   >
          <template slot-scope="scope">
            <el-tag v-if="!isLoginState">登录后查看</el-tag>
            <span v-if="isLoginState" >{{scope.row.tel}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="search-page-page">
      <el-pagination class="pagination"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="queryParams.pageNum"
                     :page-size="queryParams.pageSize"
                     :hide-on-single-page="true"
                     layout="total, prev, pager, next"
                     :total="total"
                     @pagination="getList">
      </el-pagination>
    </div>

  </el-row>

</template>
<script>
  import { listByssy } from "@/api/xwqy/byssy";
  import {updatePvNum} from "@/api/itempv/pv";
  export default {
    //首页
    name: 'yxfmzlcx',
    data(){
      return {
        // 遮罩层
        loading: false,
        // 总条数
        total: 0,
        byssyList:[],
        queryParams:{
          pageNum:1,
          pageSize:10,
          orderBy:"zhpx",
          isAsc:"asc",
        },
        isLoginState:undefined,
      }
    },
    created() {
      this.getList();
      updatePvNum("xwqycz_rcdj_byssyxx").then(response => {
        //pv 点击人才对接毕业生生源信息
      });
    },
    methods:{
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.getList();
      },
      getList() {
		  //----【】需要修改为recid
		let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
		if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
			this.isLoginState = true;
		} else {
			this.isLoginState = false;
		}
        this.loading = true;
        listByssy(this.queryParams).then(response => {
          this.byssyList = response.rows;
          this.total = response.total;
          this.loading = false;
        });
      },
      handleOrder(code){
        if(this.queryParams.orderBy==code){
          if(this.queryParams.isAsc=="asc"){
            this.queryParams.isAsc="desc";
          }else{
            this.queryParams.isAsc="asc";
          }
        }
        if(code=="zhpx"){
          this.queryParams.isAsc="asc";
        }
        this.queryParams.orderBy=code;
        this.getList();
      },
      /** 搜索按钮操作 */
      handleQuery() {
        this.queryParams.pageNum = 1;
        this.getList();
      },
    }
  }
</script>
<style scoped>
  .app-container{
    padding:0px 15px 20px;
    background-color: #ffffff;
  }

  .el-form-item{
    margin-bottom: 8px;
  }

  .el-divider--horizontal{
    display: block;
    height: 1px;
    width: 100%;
    margin: 8px 0;
  }

  .queryParamStyle{
    padding-top: 10px;
    background-color: #F5F5F5;
  }

  .search-page{
    background-color: #ffffff;
    display: flex;
  }
  .search-page-order{
    display: flex;
  }
  .order-filed{
    flex: 1;
    padding: 0px 15px;
    color:#000000;
  }

  .search-table{
    margin: 0px;
    padding: 15px;
    background-color: #ffffff;
  }

  .search-page-page{
    flex: 1;
    text-align: center;
  }
</style>
